import { useSnackbar } from "notistack";
import { useDownloadFile } from "../../components/downloadFileButton/useDownloadFile";
import { getLatestParticipantListVersionSpreadsheetForBooking } from "./participantListApi";
import dayjs from "../../dayjs";

export const useDownloadParticipantListSpreadsheet = (orderId: string) => {
  const { enqueueSnackbar } = useSnackbar();
  const { download, isLoading } = useDownloadFile<{ bookingNumber: string }>({
    apiDefinition: (_, params) => {
      if (!params) {
        throw new Error("Missing params");
      }
      return getLatestParticipantListVersionSpreadsheetForBooking(orderId, params.bookingNumber);
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się pobrać listy uczestników. Powód: ${(error as Error).message}`, {
        variant: "error",
      });
    },
    filename: (_, params) => `lista_uczestnikow_${params?.bookingNumber}_${dayjs().format("YYYY-MM-DD")}.xlsx`,
  });

  return {
    download: (bookingNumber: string) => download(undefined, { bookingNumber }),
    isLoading,
  };
};
